import React, { memo, ReactNode } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { useColorStyles } from 'transfix-ui/hooks'
import { TBrandColor } from 'transfix-ui/theme/colors'
import { FlatBedIcon, LocationPinIcon, PlusIcon, UserIcon } from 'transfix-icons'
import { TIconName } from '../../types'

interface IIconForOptionProps {
  /**
   * @example 'Add'
   */
  iconName: TIconName
  /**
   * @default 'primary'
   */
  iconColor?: TBrandColor
}

const getIcon = (iconName: TIconName): ReactNode => {
  switch (iconName) {
    case 'FlatBedIcon':
      return <FlatBedIcon />
    case 'LocationPinIcon':
      return <LocationPinIcon />
    case 'PlusIcon':
      return <PlusIcon />
    case 'UserIcon':
      return <UserIcon />
    default:
      return <></>
  }
}

const useIconForOptionStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 20,
    width: 20,
    position: 'relative',

    '& svg': {
      position: 'absolute',
      left: 0,
      width: '100%',
      top: 0,
      height: '100%',
    },
  },
})

const IconForOption = memo<IIconForOptionProps>(
  ({ iconColor = 'skyBlue6', iconName = 'PlusIcon' }) => {
    const icon = getIcon(iconName)
    const colorClasses = useColorStyles()
    const classes = useIconForOptionStyles()
    const className = classNames(classes.root, colorClasses[iconColor])
    return (
      <span data-test='icon-for-option' className={className}>
        {icon}
      </span>
    )
  }
)

export default IconForOption
